import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { Button, Title, SocialAuth } from '../components'
import { SignInForm } from '../forms'
import { signIn } from '../../common/auth/actions'
import { roles } from '../../common/config'

class SignInPage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showForm: false,
    }
  }

  render() {
    const { redirectAfterAuth, viewer, signIn, intl } = this.props
    const { showForm } = this.state
    const redirectUrl = redirectAfterAuth
    
    return (
      <React.Fragment>
        {
          viewer && viewer.role === roles.TEACHER &&
          <Redirect
            to={redirectUrl || '/app/tests'}
          />
        }
        {
          viewer && viewer.role === roles.USER &&
          <Redirect
            to={redirectUrl || '/student-landing'}
          />
        }
        {
          viewer && viewer.role === roles.ADMIN &&
          <Redirect
            to={redirectUrl || '/app/admin'}
          />
        }
        {
          !viewer &&
          <div className="user-form-wrapper sign-in-form">
            <div className="user-form">
              <Title message="Sign in" />
              <h1>{intl.formatMessage(messages.signIn)}</h1>
              <SocialAuth
                facebookLabel={intl.formatMessage(messages.facebookLabel)}
                googleLabel={intl.formatMessage(messages.googleLabel)}
              />
              <p className="form-divider">
                {intl.formatMessage(messages.or)}
              </p>
              <SignInForm signIn={signIn} />
              {/*
                showForm ?
                  <SignInForm signIn={signIn} />
                :
                  <Button
                    positive
                    icon="envelope"
                    className="user-form-button"
                    onClick={() => this.setState({ showForm: true })}
                  >
                    {intl.formatMessage(messages.emailSignIn)}
                  </Button>
              */}
              <p>
                {intl.formatMessage(messages.noAccount)}<br />
                <Link to="/sign-up"><b>{intl.formatMessage(messages.register)}</b></Link>
              </p>
              <p><Link to="/forgotten-password">{intl.formatMessage(messages.forgottenPassword)}</Link></p>
            </div>
          </div>
        }
      </React.Fragment>
    )
  }
}

SignInPage.defaultProps = {
  signIn: null,
  viewer: null,
  location: null,
  redirectAfterAuth: '',
}

SignInPage.propTypes = {
  intl: PropTypes.object.isRequired,
  location: PropTypes.object,
  viewer: PropTypes.object,
  signIn: PropTypes.func.isRequired,
  redirectAfterAuth: PropTypes.string,
}

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    redirectAfterAuth: state.app.redirectAfterAuth,
  }), { signIn }),
  injectIntl,
)

export default enhance(SignInPage)

const messages = defineMessages({
  signIn: {
    id: 'signIn.page.signIn',
    defaultMessage: 'Prihlásiť sa',
  },
  emailSignIn: {
    id: 'signIn.page.emailSignIn',
    defaultMessage: 'Prihlásiť sa cez email',
  },
  facebookLabel: {
    id: 'socialAuth.facebookLabel',
    defaultMessage: 'Pokračovať cez Facebook',
  },
  googleLabel: {
    id: 'socialAuth.googleLabel',
    defaultMessage: 'Pokračovať cez Google',
  },
  or: {
    id: 'general.or',
    defaultMessage: 'alebo',
  },
  noAccount: {
    id: 'signIn.page.noAccount',
    defaultMessage: 'Ešte nemáte učet?',
  },
  register: {
    id: 'signIn.page.register',
    defaultMessage: 'Zaregistrujte sa',
  },
  forgottenPassword: {
    id: 'signIn.page.forgottenPassword',
    defaultMessage: 'Zabudnuté heslo',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/SignInPage.js